export const keyboardKeys = [
  { key: "ESC", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key", "backslash"] },
  { key: "", classes: ["key", "tab"] },
  { key: "Q", classes: ["key"] },
  { key: "W", classes: ["key"] },
  { key: "E", classes: ["key"] },
  { key: "R", classes: ["key"] },
  { key: "T", classes: ["key"] },
  { key: "Y", classes: ["key"] },
  { key: "U", classes: ["key"] },
  { key: "I", classes: ["key"] },
  { key: "O", classes: ["key"] },
  { key: "P", classes: ["key"] },
  { key: "", classes: ["key", ""] },
  { key: "", classes: ["key", ""] },
  { key: "", classes: ["key", ""] },
  { key: "", classes: ["key", "capslock"] },
  { key: "A", classes: ["key"] },
  { key: "S", classes: ["key"] },
  { key: "D", classes: ["key"] },
  { key: "F", classes: ["key"] },
  { key: "G", classes: ["key"] },
  { key: "H", classes: ["key"] },
  { key: "J", classes: ["key"] },
  { key: "K", classes: ["key"] },
  { key: "L", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key", "return"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key", "leftshift"] },
  { key: "Z", classes: ["key"] },
  { key: "X", classes: ["key"] },
  { key: "C", classes: ["key"] },
  { key: "V", classes: ["key"] },
  { key: "B", classes: ["key"] },
  { key: "N", classes: ["key"] },
  { key: "M", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key", "rightshift"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key", "command"] },
  { key: "", classes: ["key", "space"] },
  { key: "", classes: ["key", "command"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
  { key: "", classes: ["key"] },
];
